import { finalize } from 'rxjs/operators';
import { Component, EventEmitter, Injector, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { ExpenseService } from 'src/app/core/services/expense.service';
import { SessionBaseComponent } from 'src/app/shared/components/session.base.component';
import { deepCopy, isNullOrEmpty } from 'src/app/core/utils/common-functions';
import { DropdownOptionsService } from 'src/app/core/services/dropdown-options.service';
import { CommonService } from 'src/app/features/setting/service/common.service';
import { LogisticsService } from 'src/app/features/transport-operation/services/logistics.service';
import { HttpErrorResponse } from '@angular/common/http';
import { ImportDeclarationService } from 'src/app/features/transport-operation/services/import-declaration.service';
import { CommonDataService } from 'src/app/core/services/common-data.service';
import { FacilityService } from 'src/app/core/services/facility.service';
import { WarehousingSearchService } from 'src/app/features/transport-operation/services/warehousing-search.service';
import { BookingService } from 'src/app/features/transport-operation/services/booking.service';
import { PermissionConstants } from 'src/app/core/constants/permission-constants.constant';
import { TruckCostAllocationService } from 'src/app/features/transport-operation/services/truck-cost-allocation.service';

@Component({
  selector: 'laas-billing-viewer',
  templateUrl: './billing-viewer.component.html',
  styleUrls: ['./billing-viewer.component.scss']
})
export class BillingViewerComponent extends SessionBaseComponent implements OnInit {
  @Input() display!: boolean;
  @Input() bookingNo!: any;
  @Input() feature!: any;
  @Input() bookingInfo!: any;
  @Input() deliverySubType: any = null;
  @Output() onClose = new EventEmitter<boolean>();
  billingView: any | undefined;
  columns: any[] = [
    { field: 'feeType', header: 'ImportDeclarationCostReview.CostType' },
    { field: 'accountCode', header: 'ImportDeclarationCostReview.AccountingType', width: '19.8vw' },
    { field: 'estimatedAmountDesc', header: 'ImportDeclarationCostReview.FeeRemarks' },
    { field: 'estimatedAmount', header: 'ImportDeclarationCostReview.EstimateCharges' },
    { field: 'preCurrencyCode', header: 'ImportDeclarationCostReview.EstimateCostCurrency' },
    { field: 'rate', header: 'ImportDeclarationCostReview.ExchangeRate' },
    { field: 'linePayAmount', header: 'ImportDeclarationCostReview.LinePayAmount' },
    { field: 'billingStatus', header: 'ImportDeclarationCostReview.PaymentApplicationStatus' },
    { field: 'billType', header: 'ImportDeclarationCostReview.BillType' },
    { field: 'carrierPaymentBy', header: 'ImportDeclarationCostReview.CarrierPaymentBy' },
    { field: 'guiNo', header: 'ImportDeclarationCostReview.GUINo' },
    { field: 'guiCurrency', header: 'ImportDeclarationCostReview.GUICurrency' },
    { field: 'guiAmount', header: 'ImportDeclarationCostReview.GUIAmount' },
    { field: 'invoiceType', header: 'ImportDeclarationCostReview.InvoiceType' },
    { field: 'guiDt', header: 'ImportDeclarationCostReview.GUIDt' },
    { field: 'paymentMethod', header: 'ImportDeclarationCostReview.PaymentMethod' },
    { field: 'termsId', header: 'ImportDeclarationCostReview.TermsId' },
  ];

  // this.billingView.billingViewerDetails[0].billingDetail

  currencyOptions: any[] = [];
  rates: any[] = [];
  accountCodes: any[] = [];
  billingReq: any | undefined = {
    billingCollections: []
  }
  billTypeOptions: any[] = [];
  carrierPaymentByOptions: any[] = [];
  invoiceTypeOptions: any[] = [];
  today: Date = new Date();

  forwarderOptionList: any[] = [];
  paymentMethodOptions: any[] = [];
  termsIdOptions: any[] = [];

  originBillingDetail: any = {
    accountCode: null,
    accountName: '',
    amount: 0,
    applyAmount: null,
    applyDt: null,
    billType: 'STANDARD',
    billingSeqNo: 0,
    billingStatus: '0',
    businessTaxBaseAmount: null,
    carrierPaymentBy: '',
    carrierPaymentType: '',
    confirmAmount: null,
    confirmBy: null,
    confirmDescription: null,
    createDt: null,
    createUser: '',
    cutCode: null,
    description: null,
    detailList: '',
    diffAmount: null,
    diffRatio: null,
    dueDt: null,
    estimatedAmount: 0,
    estimatedAmountDesc: null,
    facility: '',
    feeRemark: null,
    flightNo1: null,
    flyDate1: null,
    formatType: null,
    glDt: null,
    guiAmount: 0,
    guiCurrency: '',
    guiDt: new Date(),
    guiId: null,
    guiNo: null,
    inOutType: '',
    invoiceAmount: 0,
    invoiceTaxAmount: 0,
    invoiceType: '',
    lineBaseAmount: null,
    lineBaseCurrency: null,
    lineBaseRate: null,
    lineDescription: null,
    linePayAmount: 0,
    linePayCurrency: null,
    linePayRate: 1,
    linePayRateAf: null,
    linePayRateDt: null,
    linePayTaxAmount: null,
    payBaseAmount: null,
    payBaseTaxAmount: null,
    paymentMethod: '',
    preCurrencyCode: '',
    rate: 1,
    rfqDetailSeqNo: null,
    rfqFeeType: null,
    rfqOriginAmount: 0,
    rfqOriginCurrency: null,
    salerName: '',
    salerNo: '',
    seqNo: 0,
    setOfBooksId: '',
    shippingSectionDesc: null,
    shippingType: null,
    sourceType: null,
    taxCode: null,
    termsId: '',
    transERPErrorMsg: null,
    transERPFlag: null,
    updateDt: null,
    updateUser: '',
    uploadBatchNo: null,
    urgentFlag: null,
    vatCode: null,
    vendorDescription: null,
    vendorNo: null,
    vendorSiteCode: null,
  };
  billingDetail: any;

  isShowNew = true;
  isShowAddBillingBtn: boolean = false;
  isShowDeleteBillingBtn: boolean = false;

  isLoading: boolean = false;

  constructor(injector: Injector,
    private expenseService: ExpenseService,
    private logisticsService: LogisticsService,
    private dropdownOptionsService: DropdownOptionsService,
    private importDeclarationService: ImportDeclarationService,
    private commonService: CommonService,
    private commonDataService: CommonDataService,
    private bookingService: BookingService,
    private warehousingSearchService: WarehousingSearchService,
    private truckCostAllocationService: TruckCostAllocationService,
    private facilityService: FacilityService) {
    super(injector);

    this.billingDetail = deepCopy(this.originBillingDetail);
  }

  hideDialog(event: any): void {
    this.onClose.emit(this.display);
  }

  async ngOnInit(): Promise<void> {
    await super.ngOnInit();
    console.log("ngOnInit bookingNo:", this.bookingNo);

    this.isShowAddBillingBtn = this.permissionCodes.includes(PermissionConstants.BtnBillingViewerAddBilling);
    this.isShowDeleteBillingBtn = this.permissionCodes.includes(PermissionConstants.BtnBillingViewerDeleteBilling);

    this.commonService.getCurrencyOptions().subscribe({
      next: result => {
        this.currencyOptions = [...result].map((x: any) => {
          return {
            label: `${x.currency_code}`,
            value: x.currency_code,
          };
        });
      }
    });
    this.logisticsService.getAllRate().subscribe({
      next: (resolve: any[]) => {
        this.rates = resolve;
      }
    });
  }

  onEditRowCurrencyChange(event: any, index: number) {
    let rateArray = this.rates.filter(x => x.fromCurrency === event.value && x.toCurrency === this.billingView.billing.currency);
    let rate = rateArray && rateArray.length > 0 ? rateArray[0].rate : 1;
    this.billingView.billingViewerDetails[index].billingDetail.rate = rate;
    this.updateLinePayAmount(index);
  }

  handleEstimatedAmountChange(event: any, index: number) {
    this.billingView.billingViewerDetails[index].billingDetail.estimatedAmount = event.value;
    this.updateLinePayAmount(index);
  }

  updateLinePayAmount(index: number): void{
    this.billingView.billingViewerDetails[index].billingDetail.linePayAmount =
        isNullOrEmpty(this.billingView.billingViewerDetails[index].billingDetail.rate) ? 0 :
        this.billingView.billingViewerDetails[index].billingDetail.rate * this.billingView.billingViewerDetails[index].billingDetail.estimatedAmount;
  }

  async ngOnChanges(changes: SimpleChanges): Promise<void> {
    if (!this.display) {
      return;
    }

    console.log("ngOnChanges bookingNo:", this.bookingNo);

    await super.ngOnInit();

    this.checkForwarderAddBillingStatus();

    this.dropdownOptionsService.getForwarderOptions()
      .subscribe({
        next: (result: any[]) => {
          this.forwarderOptionList = result.map(x => ({ label: x.optionDesc, value: x.optionCode }));
          this.carrierPaymentByOptions = [...result].map((x: any) => {
            return {
              label: `${x.optionDesc}`,
              value: x.optionCode,
            };
          });
        }
      });

    this.commonDataService.getCodeConverter(this.laasSetting.language, 'DropdownList', 'BillType').subscribe({
      next: result => {
        this.billTypeOptions = [...result].map((x: any) => {
          return {
            label: `${x.codeKey}-${x.codeDesc}`,
            value: x.codeKey,
          };
        });
      }
    });

    this.commonDataService.getCodeConverter(this.laasSetting.language, 'DropdownList', 'InvoiceType').subscribe({
      next: result => {
        this.invoiceTypeOptions = [...result].map((x: any) => {
          return {
            label: `${x.codeKey}-${x.codeDesc}`,
            value: x.codeKey,
          };
        });
      }
    });

    this.facilityService.getExpenseOptions('PaymentMethod', null).subscribe({
      next: result => {
        this.paymentMethodOptions = [...result].map((x: any) => {
          return {
            value: `${x.optionCode}`,
            label: `${x.optionCode}-${x.optionDesc}`,
          };
        });
      }
    });

    this.facilityService.getExpenseOptions('SHT_BILL_ORIGIN.TERMS', null).subscribe({
      next: result => {
        this.termsIdOptions = [...result].map((x: any) => {
          return {
            value: x.optionCode,
            label: `${x.optionCode} - ${x.optionDesc}`,
          };
        });
      }
    });

    this.findBillingViewer();
  }

  initBillingView() {
    this.billingView = {
      billing : {
        billingNo: null,
        billingType: null,
        currency: null,
        estimateTotalCharge: '0',
        forwarderCode: null,
        expressBill: null,
        createUser: null,
        createDt: null,
        updateUser: null,
        updateDt: null,
        billCorp: null,
        orgId: null,
        facility: null,
        shipCorp: null,
        shipTerm: null,
        consigneeKey: null,
        totalGrossWeight: '0',
        updatedTotalGrossWeight: '0',
        totalVolumeWeight: '0',
        updatedTotalVolumeWeight: '0',
        awbAddress: null,
        totalCartonCnt: null,
        updatedTotalCaseCnt: '0',
        fromArea: null,
        fromCity: null,
        toCity: null,
        normalizationAddress: null,
        docNo: null,
        mawbNo: null,
        billingSubType: null,
        importDeclarationNo: null,
        splitDept: null,
        brand: null,
        permitType: null,
        isDropShipment: null,
        declarationDt: null,
        declarationType: null
      },
      billingViewerDetails: []
    };
  }

  findBillingViewer() {
    this.isLoading = true;
    this.billingView = undefined;
    if (!isNullOrEmpty(this.bookingNo)) {
      this.expenseService.findBillingViewer(this.bookingNo)
        .pipe(finalize(() => (this.isLoading = false)))
        .subscribe({
          next: async (result: any) => {

            if (result) {
              this.billingView = result;
            } else {
              this.initBillingView();
            }

            this.initBilling(result);

          },
          error: async (error: HttpErrorResponse) => {
            this.toastErrorMessage(error.error);
          }
        }
      );
    }
  }

  checkForwarderAddBillingStatus(): void {
    if (!this.bookingInfo) {
      return;
    }
    this.isShowNew = true;
    const now = new Date();
    const moreThanSixtyDaysFromCreateDt = (now.getTime() - this.bookingInfo.createDt) / (1000 * 3600 * 24) > 60;
    if (this.userProfile.userType === 'Forwarder' && moreThanSixtyDaysFromCreateDt) {
      this.isShowNew = false;
    }
  }

  onRowNew() {
    let cloneBillingDetail = deepCopy(this.billingDetail);
    cloneBillingDetail.guiDt = new Date(cloneBillingDetail.guiDt);
    this.billingView.billingViewerDetails.push({ billingDetail: cloneBillingDetail });
  }

  onRowDelete(index: number, event: any) {
    this.confirmationService.confirm({
      target: event.target,
      message: '確定要刪除嗎?',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.billingView.billingViewerDetails.splice(index, 1);
      }
    });
  }


  showValidationMessage(control: any): boolean {
    return isNullOrEmpty(control);
  }

  showAccountCode(accountCode: any): String {
    if (isNullOrEmpty(accountCode)) {
      return accountCode;
    }

    let accountCodesFilter = this.accountCodes.filter((x: any) => x.value == accountCode);
    if (accountCodesFilter.length == 1) {
      return accountCodesFilter[0].label;
    }
    return accountCode;
  }

  saveBtnClick() {
    if (isNullOrEmpty(this.billingView.billing.billingType)) {
      this.toastService.error("billingType 不能為空");
      return;
    }

    if (isNullOrEmpty(this.billingView.billing.forwarderCode)) {
      this.toastService.error("forwarderCode 不能為空");
      return;
    }

    this.billingView.billing.currency = this.billingDetail.preCurrencyCode;
    this.billingView.billing.estimateTotalCharge = this.billingDetail.estimatedAmount;
    if (this.billingView.billing.createDt == null) {
      this.billingView.billing.createDt = new Date();
    }

    this.billingView.billing.updateDt = new Date();

    this.billingView.billing.consolidationNo = this.bookingInfo.consolidationNo;
    this.billingView.billingViewerDetails.forEach((x: any) => {
      if (x.billingDetail.createDt == null) {
        x.billingDetail.createDt = new Date();
      }
      x.billingDetail.updateDt = new Date()
    });

    this.billingReq.billingCollections = [];
    this.billingReq.billingCollections.push({
      bill: this.billingView.billing,
      isManual: 1,
      billDetails: this.billingView.billingViewerDetails.length > 0 ? this.billingView.billingViewerDetails.map((x: any) => x.billingDetail) : []
    });

    if (this.billingReq.billingCollections.some((k:any) => k.billDetails.some((j:any) => isNullOrEmpty(j.accountCode) || isNullOrEmpty(j.preCurrencyCode) || isNullOrEmpty(j.estimatedAmount.toString()) || j.estimatedAmount == 0 || isNullOrEmpty(j.billType)))) {
      this.toastService.error(this.translateService.instant('BillingViewer.Error.CheckRequiredFields'));
      return;
    }

    this.isLoading = true;;
    this.expenseService.saveBilling(this.billingReq).subscribe({
      next: result => {
        this.toastService.success("儲存成功");
        this.findBillingViewer();
      },
      error: result => {
        this.isLoading = false;
        if(result.status === 400) {
          this.toastService.error("儲存失敗," + result.error?.errorMsg);
        }
        else
          this.toastService.error("儲存失敗");
      }
    });
  }

  async initBilling(billingView: any) {
    console.log('Init this.bookingInfo :', this.bookingInfo);

    this.billingDetail = deepCopy(this.originBillingDetail);

    switch (this.feature) {
      case 'Booking':
        await this.initBillingByBooking(billingView);
        break;
      case 'Warehousing':
        await this.initBillingByWarehousing(billingView);
        break;
      case 'EX-DECLARATION':
        await this.initBillingByExportDeclaration(billingView);
        break;
      case 'IN-DECLARATION':
        await this.initBillingByImportDeclaration(billingView);
        break;
      case 'CrossBoundry':
        await this.initBillingByCrossBoundry(billingView);
        break;
    }

    if (!billingView) {
      if (this.billingView.billing.billingType.indexOf("(") > -1) {
        this.billingView.billing.billingType = this.billingView.billing.billingType.substring(0, this.billingView.billing.billingType.indexOf("(")).toUpperCase();
      }

      this.billingView.billing.orgId = this.bookingInfo.orgId;
      this.billingView.billing.currency = this.bookingInfo.currency;
      this.billingView.billing.createUser = this.userProfile.loginAccount;
      this.billingView.billing.updateUser = this.userProfile.loginAccount;
      this.billingView.billing.facility = this.bookingInfo.facility;
      this.billingView.billing.billCorp = this.feature == 'EX-DECLARATION' ? this.bookingInfo.orgId : this.bookingInfo.billCorp;
    }

    this.billingDetail.seqNo = 0;
    this.billingDetail.createUser = this.userProfile.loginAccount;
    this.billingDetail.updateUser = this.userProfile.loginAccount;
    this.billingDetail.billingStatus = '0';
    this.billingDetail.facility = this.bookingInfo.facility;
    this.billingDetail.linePayAmount = this.billingDetail.estimatedAmount * this.billingDetail.rate;

    this.expenseService.billingViewerAccountCodeMap(this.billingView.billing.billingType, this.feature).subscribe({
      next: (expenseAccounts: any[]) => {
        if (this.deliverySubType === '4') {
          this.accountCodes = expenseAccounts
              .filter(x => x.accountCode.startsWith('5'))
              .map(x => ({ label: (x.accountCode + '(' + x.accountDesc + ')'), value: x.accountCode }));
        } else {
          this.accountCodes = expenseAccounts.map(x => ({ label: (x.accountCode + '(' + x.accountDesc + ')'), value: x.accountCode }));
        }
      }
    });

    this.billingView.billingViewerDetails.forEach((x: any) => {
      if (!isNullOrEmpty(x.billingDetail.accountCode)){
        let idx = x.billingDetail.accountCode.indexOf('(');
        if (idx > 0) {
          x.billingDetail.accountCode = x.billingDetail.accountCode.substring(0, idx);
        }
      }
      if (!isNullOrEmpty(x.billingDetail.guiDt)) {
        x.billingDetail.guiDt = new Date(x.billingDetail.guiDt);
      }
    });

    this.billingDetail.guiDt = new Date();

    console.log('Init this.billingView :', this.billingView);
    console.log('Init this.billingDetail :', this.billingDetail);
  }

  async initBillingByBooking(billingView: any) {
    if (!billingView) {
      this.bookingInfo = await this.bookingService.getBookingHeaderDetail(this.bookingInfo.bookingNo).toPromise();
      this.bookingInfo.bookingDetails = (await this.bookingService.getBookingDetail(this.bookingInfo.facility, this.bookingInfo.bookingNo).toPromise())?.searchBookingDetailList;
      this.billingView.billing.billingNo = this.bookingInfo.bookingNo;
      this.billingView.billing.billingType = this.bookingInfo.deliveryType;
      this.billingView.billing.currency = this.bookingInfo.currency;

      this.billingView.billing.forwarderCode = this.bookingInfo.bookingForwarder;
      this.billingView.billing.expressBill = this.bookingInfo.expressBill;
      this.billingView.billing.shipCorp = this.bookingInfo.shipCorp;
      this.billingView.billing.shipTerm = this.bookingInfo.incoTerm;
      this.billingView.billing.consigneeKey = this.bookingInfo.consigneeKey;
      this.billingView.billing.totalGrossWeight = this.bookingInfo.totalGrosswgt;
      this.billingView.billing.updatedTotalGrossWeight = this.bookingInfo.updatedTotalGrossWeight;
      this.billingView.billing.totalVolumeWeight = this.bookingInfo.totalVolumeWeight;
      this.billingView.billing.updatedTotalVolumeWeight = this.bookingInfo.updatedTotalVolumeWeight;
      this.billingView.billing.awbAddress = this.bookingInfo.awbAddress;
      this.billingView.billing.totalCartonCnt = this.bookingInfo.totalCaseCnt;
      this.billingView.billing.updatedTotalCaseCnt = this.bookingInfo.updatedTotalCaseCnt;
      this.billingView.billing.fromCountry = this.bookingInfo.fromCountry;
      this.billingView.billing.fromCity = this.bookingInfo.fromCity;
      this.billingView.billing.fromArea = this.bookingInfo.fromArea;
      this.billingView.billing.toCountry = this.bookingInfo.toCountry;
      this.billingView.billing.toCity = this.bookingInfo.toCity;
      this.billingView.billing.toArea = this.bookingInfo.toArea;
      this.billingView.billing.normalizationAddress = this.bookingInfo.normalizationAddress;
      this.billingView.billing.mawbNo = this.bookingInfo.mawb;
      this.billingView.billing.billingSubType = this.bookingInfo.deliverSubType;
      this.billingView.billing.totalGrossWeight = this.bookingInfo.totalGrossWeight;
      this.billingView.billing.totalCartonCnt = this.bookingInfo.totalCartonCnt;
      this.billingView.billing.forwarder = this.bookingInfo.bookingForwarder;
      this.billingView.billing.carTrip = this.bookingInfo.carTrip;
      this.billingView.billing.bookingCreateDt = this.bookingInfo.createDt;
    }

    this.initBillingDetailByBooking();
  }

  initBillingDetailByBooking() {
    this.billingDetail.inOutType = 'O';
    this.billingDetail.inOutKey = this.bookingInfo.bookingNo;
    this.billingDetail.sourceType = 'DeliveryOrder';
    this.billingDetail.carrierPaymentBy = this.bookingInfo.carrierPaymentBy;
    this.billingDetail.carrierPaymentType = this.bookingInfo.carrierPaymentType;
    this.billingDetail.flightNo1 = this.bookingInfo.flightNo1;
    this.billingDetail.flyDate1 = this.bookingInfo.flyDate1;
    this.billingDetail.detailList = this.bookingInfo?.bookingDetails?.map((bookingDetail: any) => bookingDetail.doNo)?.join(',');
    if (this.bookingInfo.bookingStatus == '-1' ||
      this.bookingInfo.bookingStatus == '0'||
      this.bookingInfo.bookingStatus == 'C' ||
      this.bookingInfo.bookingStatus == '1') {
        this.isShowNew = false;
    }
  }

  async initBillingByWarehousing(billingView: any) {
    if (!billingView) {
      this.bookingInfo = await this.warehousingSearchService.searchWarehousingByWhNo(this.bookingInfo.whNo);
      this.billingView.billing.billingNo = this.bookingInfo.whNo;
      this.billingView.billing.billingType = this.bookingInfo.deliveryType;

      this.billingView.billing.forwarderCode = this.bookingInfo.shipper;
      this.billingView.billing.expressBill = this.bookingInfo.hawbNo;
      this.billingView.billing.shipCorp = this.bookingInfo.orgId;
      this.billingView.billing.shipTerm = this.bookingInfo.shipTerm;
      this.billingView.billing.totalGrossWeight = this.bookingInfo.totalGrossWeight;
      this.billingView.billing.updatedTotalGrossWeight = this.bookingInfo.updatedTotalGrossWeight;
      this.billingView.billing.totalVolumeWeight = this.bookingInfo.totalVolumeWeight;
      this.billingView.billing.updatedTotalVolumeWeight = this.bookingInfo.updatedTotalVolumeWeight;
      this.billingView.billing.awbAddress = this.bookingInfo.deliveryAddress;
      this.billingView.billing.totalCartonCnt = this.bookingInfo.totalCartonCnt;
      this.billingView.billing.updatedTotalCaseCnt = this.bookingInfo.updatedTotalCaseCnt;
      this.billingView.billing.fromCountry = this.bookingInfo.fromCountry;
      this.billingView.billing.fromCity = this.bookingInfo.fromCity;
      this.billingView.billing.fromArea = this.bookingInfo.fromArea;
      this.billingView.billing.toCountry = this.bookingInfo.toCountry;
      this.billingView.billing.toCity = this.bookingInfo.toCity;
      this.billingView.billing.toArea = this.bookingInfo.toArea;
      this.billingView.billing.mawbNo = this.bookingInfo.mawbNo;
      this.billingView.billing.billingSubType = this.bookingInfo.deliverySubType;

      let searchObj: any = {
        whNo: []
      };
      searchObj.whNo.push(this.bookingInfo.whNo);
      this.importDeclarationService.getImportHeader(searchObj)
        .subscribe({
          next: result => {
            if (result != null && result.length == 1)
              this.billingView.billing.importDeclarationNo = result[0].importDeclarationNo;
          }
        }
      );

      this.billingView.billing.splitDept = this.bookingInfo.splitDept;
      this.billingView.billing.brand = this.bookingInfo.brand;
      this.billingView.billing.permitType = this.bookingInfo.permitType;
      this.billingView.billing.isDropShipment = this.bookingInfo.isDropShipment;
      this.billingView.billing.totalGrossWeight = this.bookingInfo.totalGrossWeight;
      this.billingView.billing.totalCartonCnt = this.bookingInfo.totalCartonCnt;
    }

    this.initBillingDetailByWarehousing();
  }

  initBillingDetailByWarehousing() {
    this.billingDetail.inOutType = 'I';
    this.billingDetail.inOutKey = this.bookingInfo.whNo;
    this.billingDetail.carrierPaymentType = this.bookingInfo.billObjectType;
    this.billingDetail.carrierPaymentBy = this.bookingInfo.billObject;
    this.billingDetail.vendorNo = this.bookingInfo.vendorCustomer;
    if (this.bookingInfo.whStatus  == '0' ||
      this.bookingInfo.whStatus  == '1' ||
      this.bookingInfo.whStatus  == 'C') {
      this.isShowNew = false;
    }
  }

  initBillingByExportDeclaration(billingView: any) {
    if (!billingView) {
      this.billingView.billing.billingNo = this.bookingInfo.exportDeclarationNo;
      if (isNullOrEmpty(this.billingView.billing.billingType)) {
        this.billingView.billing.billingType = 'EX-DECLARATION';
      }


      this.billingView.billing.docNo = this.bookingInfo.docNo;
      this.billingView.billing.mawbNo = this.bookingInfo.mawbNo;

      this.billingView.billing.forwarderCode = this.bookingInfo.bookingForwarder;
      this.billingView.billing.expressBill = this.bookingInfo.expressBill;
      this.billingView.billing.docNo = this.bookingInfo.docNo;
      this.billingView.billing.mawbNo = this.bookingInfo.mawbNo;
      this.billingView.billing.declarationDt = this.bookingInfo.exportDt;
      this.billingView.billing.consigneeKey = this.bookingInfo.consigneeKey;
      this.billingView.billing.forwarder = this.bookingInfo.bookingForwarder;
      this.billingView.billing.shipTerm = this.bookingInfo.shipTerm;
      this.billingView.billing.bookingCreateDt = this.bookingInfo.createDt;
    }

    this.initBillingDetailByExportDeclaration();
  }

  initBillingDetailByExportDeclaration() {
    this.billingDetail.inOutType = 'B';
    this.billingDetail.inOutKey = this.bookingInfo.exportDeclarationNo;
    this.billingDetail.carrierPaymentType = this.bookingInfo.billObjectType;
    this.billingDetail.carrierPaymentBy = this.bookingInfo.billObject;
    this.billingDetail.setOfBooksId = this.bookingInfo.setOfBooksId;
    this.billingDetail.flightNo1 = this.bookingInfo.flyNo1;
    this.billingDetail.flyDate1 = this.bookingInfo.flyDt1;
    this.billingDetail.detailList = this.bookingInfo?.details?.map((exportDetail: any) => exportDetail.doNo)?.join(',');
    if (this.bookingInfo.status  != '2') {
        this.isShowNew = false;
    }
  }

  initBillingByImportDeclaration(billingView: any) {
    if (!billingView) {
      this.billingView.billing.billingNo = this.bookingInfo.importDeclarationNo;
      if (isNullOrEmpty(this.billingView.billing.billingType)) {
        this.billingView.billing.billingType = 'IN-DECLARATION';
      }

      this.billingView.billing.fromCity = this.bookingInfo.exportCityCode;
      this.billingView.billing.docNo = this.bookingInfo.docNo;


      this.billingView.billing.forwarderCode = this.bookingInfo.forwarder;
      this.billingView.billing.expressBill = this.bookingInfo.expressBill;
      this.billingView.billing.fromCity = this.bookingInfo.exportCityCode;
      this.billingView.billing.docNo = this.bookingInfo.docNo;
      this.billingView.billing.mawbNo = this.bookingInfo.mawbNo;
      this.billingView.billing.declarationDt = this.bookingInfo.importDt;
      this.billingView.billing.declarationType = this.bookingInfo.importType;
      this.billingView.billing.sourceType = 'Advising';
    }

    this.initBillingDetailByImportDeclaration();
  }

  initBillingDetailByImportDeclaration() {
    this.billingDetail.inOutType = 'A';
    this.billingDetail.carrierPaymentType = this.bookingInfo.billObjectType;
    this.billingDetail.carrierPaymentBy = this.bookingInfo.billObject;
    this.billingDetail.vendorNo = this.bookingInfo.vendorCustomer;
    if (this.bookingInfo.whStatus  == '0' ||
      this.bookingInfo.whStatus  == '1' ||
      this.bookingInfo.whStatus  == 'C') {
      this.isShowNew = false;
    }
  }

  async initBillingByCrossBoundry(billingView: any) {
    var inOutType = null;
    if (!billingView) {
      this.bookingInfo =  await this.truckCostAllocationService.searchCrossBoundryByCBNo(this.bookingInfo.crossBoundryNo);
      console.log(' this.bookingInfo '+ this.bookingInfo );
      this.billingView.billing.billingNo = this.bookingInfo.crossBoundryNo;
      this.billingView.billing.billingType = this.bookingInfo.deliveryType;
      this.billingView.billing.currency = this.bookingInfo.currency;

      this.billingView.billing.forwarderCode = this.bookingInfo.shipForwarder;

      this.billingView.billing.totalVolumeWeight = this.bookingInfo.totalVolumeWeight;
      this.billingView.billing.fromCountry = this.bookingInfo.fromCountry;
      this.billingView.billing.fromCity = this.bookingInfo.fromCity;
      this.billingView.billing.fromArea = this.bookingInfo.fromArea;
      this.billingView.billing.toCountry = this.bookingInfo.toCountry;
      this.billingView.billing.toCity = this.bookingInfo.toCity;
      this.billingView.billing.toArea = this.bookingInfo.toArea;
      this.billingView.billing.totalGrossWeight = this.bookingInfo.totalGrossWeight;
      this.billingView.billing.totalCartonCnt = this.bookingInfo.cartonCnt;
      this.billingView.billing.bookingCreateDt = this.bookingInfo.createDt;
    }
    inOutType = this.bookingInfo.referenceType == 'Booking' ? 'O' : 'I';
    console.log('this.bookingInfo.referenceType '+this.bookingInfo.referenceType );
    this.initBillingDetailByCrossBoundry(inOutType);
  }

  initBillingDetailByCrossBoundry(inOutType : string) {
    this.billingDetail.inOutType = inOutType;
    this.billingDetail.sourceType = inOutType === 'O' ? 'DeliveryOrder' : 'Advising';
    console.log('inOutType '+inOutType);

    this.billingDetail.inOutKey = this.bookingInfo.crossBoundryNo;
    this.billingDetail.carrierPaymentType = this.bookingInfo.billObjectType;
    this.billingDetail.carrierPaymentBy = this.bookingInfo.carrierPaymentBy;
    this.billingDetail.vendorNo = this.bookingInfo.vendor;
    this.billingDetail.setOfBooksId = this.bookingInfo.setOfBooksId;
    this.billingDetail.businessTaxBaseAmount = this.bookingInfo.estimatedGVAcctdAmount;
    this.billingDetail.detailList = this.bookingInfo?.detailList?.join(',');
    console.log('this.billingDetail.detailList'+this.billingDetail.detailList);
    this.billingDetail.estimatedGVAcctdAmount = this.bookingInfo?.estimatedGVAcctdAmount;
    if (this.bookingInfo.isActivated  != 'Y') {
      this.isShowNew = false;
    }
  }

}
